import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import { 
  getUserCustomerAccess, 
  shouldShowCustomerSelector, 
  getCustomerOptions,
  setActiveCustomer 
} from '../../_metronic/helpers/UserRoleHelpers';

export const InactiveCustomerWarning: React.FC = () => {
  const intl = useIntl();
  const { user } = useAuth0();
  const history = useHistory();
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [hasMultipleCustomers, setHasMultipleCustomers] = useState(false);
  const [customerOptions, setCustomerOptions] = useState<Array<{ label: string; value: string }>>([]);

  useEffect(() => {
    if (user) {
      const access = getUserCustomerAccess(user);
      const currentCustomer = window.localStorage.getItem('activeCustomer') || access.primaryCustomer || access.customers[0] || '';
      setSelectedCustomer(currentCustomer);
      
      if (shouldShowCustomerSelector(user)) {
        setHasMultipleCustomers(true);
        setCustomerOptions(getCustomerOptions(user));
      }
    }
  }, [user]);

  const handleCustomerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setActiveCustomer(e.target.value);
    history.go(0); // Recarrega a página
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-center flex-column-fluid p-10">
        <div className="text-center">
          {/* Icon */}
          <div className="mb-10">
            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '8rem' }}></i>
          </div>

          {/* Title */}
          <h1 className="fw-bold mb-5">
            {intl.formatMessage({
              id: 'inactive-customer.title',
              defaultMessage: 'Conta Inativa',
            })}
          </h1>

          {/* Message */}
          <div className="fw-semibold fs-3 text-gray-600 mb-10 px-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {intl.formatMessage({
              id: 'inactive-customer.message',
              defaultMessage:
                'Sua conta está temporariamente inativa. Para reativar o acesso e continuar utilizando nossos serviços, entre em contato com nossa equipe.',
            })}
          </div>

          {/* Contact Info */}
          <div className="card shadow-sm" style={{ maxWidth: '500px', margin: '0 auto' }}>
            <div className="card-body p-8">
              <h3 className="card-title mb-5">
                {intl.formatMessage({
                  id: 'inactive-customer.contact-title',
                  defaultMessage: 'Como entrar em contato:',
                })}
              </h3>

              <div className="d-flex flex-column gap-4">
                {/* Email */}
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-40px me-4">
                    <div className="symbol-label bg-light-primary">
                      <i className="bi bi-envelope-fill text-primary fs-2"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="text-gray-800 fw-bold fs-6">Email</div>
                    <a href="mailto:suporte@konfidency.com.br" className="text-primary fw-semibold">
                      suporte@konfidency.com.br
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-40px me-4">
                    <div className="symbol-label bg-light-success">
                      <i className="bi bi-whatsapp text-success fs-2"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="text-gray-800 fw-bold fs-6">WhatsApp</div>
                    <a
                      href="https://wa.me/551151980535"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-success fw-semibold"
                    >
                      (11) 5198-0535
                    </a>
                  </div>
                </div>

                {/* Portal */}
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-40px me-4">
                    <div className="symbol-label bg-light-info">
                      <i className="bi bi-chat-dots-fill text-info fs-2"></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="text-gray-800 fw-bold fs-6">
                      {intl.formatMessage({
                        id: 'inactive-customer.support-portal',
                        defaultMessage: 'Portal de Suporte',
                      })}
                    </div>
                    <a
                      href="https://help.konfidency.com.br"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info fw-semibold"
                    >
                      help.konfidency.com.br
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="text-muted fs-6 mt-8">
            {intl.formatMessage({
              id: 'inactive-customer.footer',
              defaultMessage: 'Nossa equipe está pronta para ajudar você a reativar sua conta rapidamente.',
            })}
          </div>

          
        </div>

        
      </div>

                {/* Customer Selector - se tiver múltiplas contas */}
                {hasMultipleCustomers && (
            <div className="mb-8" style={{ maxWidth: '400px', margin: '0 auto' }}>
              <div className="alert alert-info d-flex align-items-center">
                <i className="bi bi-info-circle-fill me-2"></i>
                <div className="flex-grow-1">
                  {intl.formatMessage({
                    id: 'inactive-customer.switch-account',
                    defaultMessage: 'Você tem acesso a outras contas. Selecione uma conta ativa:',
                  })}
                </div>
              </div>
              <select
                className="form-select form-select-lg"
                value={selectedCustomer}
                onChange={handleCustomerChange}
              >
                {customerOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
    </div>
  );
};

